const _ = require('underscore');
const React = require("react");
const createReactClass = require("create-react-class");

const form = require('../../../deploynaut/js/Form.jsx');

const SpeedCurveForm = createReactClass({
	getInitialState: function() {
		const state = {
			id: null,
			apiKey: "",
			siteId: ""
		};

		const integration = this.props.integration;
		if (integration && integration.options !== undefined) {
			state.id = integration.id;
			state.apiKey = integration.options.APIKey;
			state.siteId = integration.options.SiteID;
		}

		return state;
	},

	render() {
		return (
			<div className="integration-form">
				<p>
					Enabling the <a href='https://speedcurve.com' target="_new">SpeedCurve</a> integration will
					automatically trigger a round of performance testing on your website after a successful deployment.
				</p>

				<form.Form
					ref="speedcurveForm"
					url={this.props.model.UpdateURL}
					securityID={this.props.model.InitialSecurityID}
					buttonTitle="Save"
					buttonSubmittingTitle="Saving"
					afterSuccess={this.props.afterSuccess}
				>
					<div className="form-group">
						<label htmlFor="APIKey">API Key</label>
						<form.Input
							name="APIKey"
							required
							validationError="Please enter a valid API key"
							placeholder="API Key"
							value={this.state.apiKey}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="SiteID">Site ID</label>
						<form.Input
							name="SiteID"
							required
							validationError="Please enter the ID of the site you'd like to trigger testing on."
							placeholder="Site ID"
							value={this.state.siteId}
						/>
					</div>


					<form.Hidden name="Type" value="SpeedCurve" />
					<form.Hidden name="ID" value={this.state.id} />
				</form.Form>
			</div>
		);
	}
});

module.exports = SpeedCurveForm;
